module.exports = __webpack_public_path__ + "assets/img/2c246dbed534bf9708cfa96a46a369cf.png";